// extracted by mini-css-extract-plugin
export var active = "_ht-2";
export var recordingDot = "_ht-1";
export var recordingIndicator = "_ht-0";